import axios from "../axios";
import { endpoints } from "../endpoint";

/**
 * Create a new driver pre-onboarding record
 * @param {Object} payload - Pre-onboarding data
 * @param {string} payload.financierType - Type of financier (LTO, AMU, MOOVING)
 * @param {Object} payload.driverDetails - Driver information
 * @param {Object} payload.vehicleFinancierDetails - Financier details (optional)
 * @param {Object} payload.documents - Uploaded document URLs
 * @returns {Promise<Object>} Response data with PRN
 */
export const createDriverPreOnboarding = async (payload) => {
  try {
    const response = await axios.post(
      endpoints.createPreOnboardingDriver,
      payload,
      {
        headers: {
          "Content-Type": "application/json",
        },
        timeout: 30000, // 30 second timeout
      },
    );

    return response.data;
  } catch (error) {
    console.error("Create driver pre-onboarding failed:", error);

    // Re-throw with better error message
    if (error.response) {
      // Server responded with error
      throw new Error(
        error.response.data?.message ||
          `Server error: ${error.response.status}`,
      );
    } else if (error.request) {
      // Request made but no response
      throw new Error("No response from server. Please check your connection.");
    } else {
      // Something else happened
      throw new Error(error.message || "Failed to create pre-onboarding");
    }
  }
};

export const getPreOnboardingDriverByPnr = async (prn) => {
  const response = await axios.get(
    `${endpoints.getPreOnboardingDriverByPrn}/${prn}`,
  );

  return response.data;
};

export const updatePreOnboardingDriver = async (prn, payload) => {
  const response = await axios.patch(
    `${endpoints.updatePreOnboardingDriver}/${prn}`,
    payload,
  );

  return response.data;
};
